import moment from "moment";
import ReactCountryFlag from "react-country-flag";
import ReactTooltip from "react-tooltip";
import { Modal } from "react-bootstrap";
import LocalStorageService from "../../../core/services/local-storage.service";
import { getIntelUrl } from "@utils/intelUrl";
import { countryCapsToSmall, filterDictonary, intelAPIEndpoints, redirectionUrls } from "@routes/intel/dashboard/const";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { Suspense, lazy, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { filterTypeDictionary } from "@core/global/global-country-dictionary";
import { getTitleCase } from "@utils/utils";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { useLocation } from "react-router-dom";
import SaveSearch from "@containers/shipments/components/RightPanel/components/SaveSearch";
import ShareSearch from "./components/shareSearch";
import { getActiveUserOrganisation } from "@containers/shipments/components/RightPanel/components/SaveSearch/services";
import { useSelector } from "react-redux";
import { CountryCodeOneToOneMap, DATASET_TYPE_MAPPING, getDatasetDisplayName, HIDE_DATASET_IDENTITY, isUniversalSearchDataset } from "@core/dictionary/global";
const ViewSavedSearch = lazy(() => import("./components/ViewSavedSearch"));
const localStorageService = LocalStorageService.getService();
const TABENUM = {
  current: "current",
  shared: "shared",
};

const reloadBtnCls = "tw-rounded-lg tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-text-primary-purple-600 hover:tw-bg-gray-200 tw-flex tw-items-center tw-text-center tw-cursor-pointer tw-gap-1";

const SavedSearches = ({ savedSearchData, isLoading, getDashboardContacts, fromShipments = false, onReload = null }) => {
  const location = useLocation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSearchDeatilsModal, setShowSearchDeatilsModal] = useState(false);
  const [showEditSearchModal, setShowEditSearchModal] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const [filterCountry, setfilterCountry] = useState("");
  const [openShareModal, setOpenShareModal] = useState(false);
  const [sharedSearchData, setSharedSearchData] = useState([]);
  const [currentSearchData, setCurrentSearchData] = useState([]);
  const [currentTab, setCurrentTab] = useState(TABENUM.current);
  const [shareUserOptions, setShareUserOptions] = useState([]);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const getActiveUsers = async () => {
    const { data } = await getActiveUserOrganisation();
    let options = data?.map((item) => ({ label: `${item.name} (${item.email})`, value: item }));
    setShareUserOptions(options);
  };
  useEffect(() => {
    const searchUrlParams = window.location.search;
    if (new URLSearchParams(searchUrlParams).get("activeIndex")) {
      setCurrentTab(TABENUM.shared);
    } else {
      setCurrentTab(TABENUM.current);
    }
  }, []);

  useEffect(() => {
    if (currentTab === TABENUM.shared) {
      setSharedSearchData(
        groupBySharedName(
          savedSearchData?.data?.filter((item) => item?.is_shared === true),
          "shared_by"
        )
      );
    } else {
      setCurrentSearchData(savedSearchData?.data?.filter((item) => !item?.is_shared));
    }
    if (shareUserOptions.length === 0) getActiveUsers();
  }, [currentTab, savedSearchData]);

  const reloadSavedSearch = (data) => {
    let key = !!data && !!data.country_code && !!data.trade_direction ? (data.country_code.toLowerCase() === "gb" ? "uk" : data.country_code.toLowerCase() === "cl" ? "ch" : data.country_code.toLowerCase() === "pe" ? "pr" : data.country_code.toLowerCase()) : data.country_code ? data.country_code : data.country?.toLowerCase() === "global data" ? "global" : "";
    key = key + "_" + data.trade_direction.toLowerCase();
    if (!redirectionUrls[key]) return;
    localStorageService.setDataToLocalStorage("reloadSavedSearch", data);
    // When embedded in the shipments page reload in the same tab; on the standalone page open a new tab.
    const target = fromShipments ? "_self" : "_blank";
    const url = data.url.includes("isReload=true") ? getIntelUrl() + redirectionUrls[key] + data.url : getIntelUrl() + redirectionUrls[key] + "?isReload=true" + (!!data.source && typeof data.source === "string" && data.source.toLowerCase() === "redirection" && !!data.url && data.url.includes("redirectingFrom=") === true ? data.url.replace("?", "&") : "");
    // Embedded in shipments: let the parent reload in place when already on the target dataset.
    if (fromShipments && onReload) onReload(data, url);
    else window.open(url, target);
  };

  const deleteSavedSearch = (thisData) => {
    trademoTrackingEvents(trackingEventDictionary.dashboardSearchHistoryDeleteSavedSearch, { ...generateTrackingObject(location.pathname) });
    setShowDeleteModal(false);
    setCurrentItem({});
    if (thisData?.search_name) {
      let payload = { search_name: thisData.search_name };
      const apiUrl = intelAPIEndpoints.deleteSavedSearchByName;
      axios.post(apiUrl, payload).then(
        (res) => {
          if (!!res && !!res.data) {
            if (!!res.data.status && res.data.status.toLowerCase() === "success".toLocaleLowerCase()) {
              toast.success(res.data.message);
              getDashboardContacts();
            } else {
              toast.error("Something went wrong. Please try again later!!!");
            }
          }
        },
        () => {
          toast.error("Something went wrong. Please try again later!!!");
        }
      );
    } else {
      toast.error("Something went wrong. Please try again later!!!");
    }
  };

  const groupBySharedName = (array = [], key) => {
    return array.reduce((result, obj) => {
      const value = obj[key];
      if (!result[value]) {
        result[value] = [];
      }
      result[value].push(obj);
      return result;
    }, {});
  };

  const groupByDate = (array = []) => {
    return array.reduce((result, obj) => {
      const date = moment(obj.created_at).format("MMM DD, YYYY");
      if (!result[date]) result[date] = [];
      result[date].push(obj);
      return result;
    }, {});
  };

  const renderCountryFlag = (searchData) => {
    if (HIDE_DATASET_IDENTITY) return <></>;
    if (!searchData?.country_code) return <></>;
    if (searchData?.country_code === "world" || searchData?.country?.toLowerCase() === "global data") {
      return (
        <svg className="tw-mr-2 tw-mb-1" xmlns="http://www.w3.org/2000/svg" fill="#6f08f1" height="16" viewBox="0 -960 960 960" width="16">
          <path d="M480.239-71.87q-84.647 0-159.095-32.097-74.448-32.098-129.644-87.294-55.196-55.195-87.294-129.65-32.097-74.455-32.097-159.109 0-84.654 32.097-159.089 32.098-74.435 87.294-129.63 55.196-55.196 129.65-87.294 74.455-32.098 159.109-32.098 84.654 0 158.969 32.098 74.316 32.098 129.511 87.294 55.196 55.195 87.294 129.65 32.098 74.455 32.098 159.109 0 84.654-32.098 159.089t-87.294 129.63q-55.195 55.196-129.568 87.294-74.372 32.098-158.932 32.098Zm-39.761-93v-77.76q-32.761 0-56.025-23.266-23.265-23.266-23.265-55.937v-39.602L171.109-551.522q-3 17.761-5.5 35.522t-2.5 35.627q0 120.098 78.782 210.42 78.783 90.323 198.587 105.083Zm273.609-101.043q20-21.761 35.641-47.022 15.642-25.261 26.142-52.641 10.5-27.381 15.88-56.223 5.38-28.842 5.38-58.679 0-97.009-53.782-177.189-53.783-80.181-144.065-115.703v15.522q0 32.704-23.5 55.994-23.5 23.289-56.151 23.289h-79.154v79.211q0 16.832-11.5 28.332t-28.332 11.5h-79.211v79.044h237.99q16.858 0 28.358 11.5t11.5 28.322v118.743h39.282q26 0 46.799 15.5t28.723 40.5Z" />
        </svg>
      );
    }
    if (searchData?.country_code?.toLowerCase() === "middleeast") {
      return <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg" className="tw-h-3.5 tw-w-3.5 tw-mr-2" />;
    }
    if (CountryCodeOneToOneMap[searchData?.country_code.toLowerCase()]) {
      return <ReactCountryFlag className="trademo-search-flag tw-mr-2" countryCode={CountryCodeOneToOneMap[searchData?.country_code.toLowerCase()]} svg />;
    }
    return <ReactCountryFlag className="trademo-search-flag tw-mr-2" countryCode={searchData.country_code} svg />;
  };

  const renderSavedSearchItem = (searchData, tabType) => (
    <div key={`recent_search${searchData.search_name}`} className="tw-border tw-border-gray-200 tw-px-2 tw-py-3 tw-rounded-lg tw-flex tw-justify-between tw-items-center">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <span className="tw-text-sm tw-font-medium tw-text-gray-max">
          <span data-for={`saved_search${searchData.search_name}`} data-tip={searchData.search_name.length < 25 ? "" : getTitleCase(searchData.search_name)}>
            {getTitleCase(searchData.search_name.slice(0, 25))}
            {searchData.search_name.length > 25 && "..."}
          </span>
          <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" id={`saved_search${searchData.search_name}`} />
          <svg
            onClick={() => {
              setCurrentItem(searchData);
              setShowSearchDeatilsModal(true);
              setfilterCountry(searchData && searchData.country_code && searchData.trade_direction ? (searchData.country_code === "PE" ? "PR".toLowerCase() + "_" + searchData.trade_direction.toLowerCase() : searchData.country_code === "GB" ? "UK".toLowerCase() + "_" + searchData.trade_direction.toLowerCase() : searchData.country_code.toLowerCase() + "_" + searchData.trade_direction.toLowerCase()) : searchData.country.toLowerCase() === "global data" ? "global_imports" : "");
            }}
            className="tw-mb-1 tw-ml-2 tw-cursor-pointer"
            fill="#101828"
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M120-120v-240h80v104l124-124 56 56-124 124h104v80H120Zm480 0v-80h104L580-324l56-56 124 124v-104h80v240H600ZM324-580 200-704v104h-80v-240h240v80H256l124 124-56 56Zm312 0-56-56 124-124H600v-80h240v240h-80v-104L636-580Z" />
          </svg>
        </span>
        {/* With the dataset identity hidden this whole line is empty, and the stray
            space still draws a blank row - but the shared tab keeps its date here. */}
        {(!HIDE_DATASET_IDENTITY || (tabType === TABENUM.shared && searchData?.created_at)) && (
          <span>
            {renderCountryFlag(searchData)}
            <span className="tw-text-sm tw-font-normal tw-text-gray-900 tw-capitalize">
              {getDatasetDisplayName(searchData.country, getTitleCase(searchData.country || ""))} {!isUniversalSearchDataset(searchData.country, searchData.country_code) && searchData?.trade_direction && `${getTitleCase(searchData.trade_direction)}`}
              {DATASET_TYPE_MAPPING[`${searchData?.country_code?.toLowerCase()}_${searchData?.trade_direction?.toLowerCase()?.endsWith("s") ? searchData?.trade_direction?.toLowerCase()?.slice(0, -1) : searchData?.trade_direction?.toLowerCase()}`]}
              {tabType === TABENUM.shared && searchData?.created_at && <span className="tw-font-medium tw-text-xs tw-text-gray-500 tw-ml-2">{moment(searchData.created_at).format("MMM DD, YYYY")}</span>}
            </span>
          </span>
        )}
      </div>
      <div className="tw-text-sm tw-font-medium tw-text-primary-purple-500 tw-gap-2 tw-flex tw-items-center">
        <div
          className={reloadBtnCls}
          onClick={() => {
            setCurrentItem(searchData);
            setShowEditSearchModal(true);
          }}>
          {searchData.is_email_alert === true ? "Edit Alert" : "Set Alert"}
          {searchData.is_email_alert === true ? (
            <svg className="tw-ml-0" xmlns="http://www.w3.org/2000/svg" fill="#7143f1" height="16px" viewBox="0 -960 960 960" width="16px">
              <path d="M104.617-563.462q0-88.46 37.577-163.306 37.576-74.846 101.421-126.384l37 46.691q-53.461 43.231-84.73 106-31.269 62.769-31.269 136.999h-59.999Zm690.767 0q0-74.23-31.269-137.191-31.269-62.962-84.73-106.192l37-46.307q63.845 51.538 101.421 126.384 37.577 74.846 37.577 163.306h-59.999ZM180.001-204.616v-59.998h72.308v-298.463q0-80.692 49.807-142.692 49.808-62 127.885-79.307v-24.923q0-20.769 14.615-35.384 14.615-14.616 35.384-14.616t35.384 14.616q14.615 14.615 14.615 35.384v24.923q78.077 17.307 127.885 79.307 49.807 62 49.807 142.692v298.463h72.308v59.998H180.001ZM480-497.692Zm0 405.383q-29.923 0-51.115-21.192-21.192-21.192-21.192-51.115h144.614q0 29.923-21.192 51.115Q509.923-92.309 480-92.309ZM312.307-264.614h335.386v-298.463q0-69.462-49.116-118.577Q549.462-730.77 480-730.77q-69.462 0-118.577 49.116-49.116 49.115-49.116 118.577v298.463Z" />
            </svg>
          ) : (
            <svg className="tw-ml-0" fill="#7143f1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px">
              <path d="M180.001-204.616v-59.998h72.308v-298.463q0-80.692 49.807-142.692 49.808-62 127.885-79.307v-24.923q0-20.833 14.57-35.416 14.57-14.584 35.384-14.584t35.429 14.584q14.615 14.583 14.615 35.416v24.923q78.077 17.307 127.885 79.307 49.807 62 49.807 142.692v298.463h72.308v59.998H180.001ZM480-497.692Zm-.068 405.383q-29.855 0-51.047-21.24-21.192-21.24-21.192-51.067h144.614q0 29.923-21.26 51.115-21.26 21.192-51.115 21.192ZM312.307-264.614h335.386v-298.463q0-69.462-49.116-118.577Q549.462-730.77 480-730.77q-69.462 0-118.577 49.116-49.116 49.115-49.116 118.577v298.463Z" />
            </svg>
          )}
        </div>
        <div
          className={reloadBtnCls}
          onClick={() => {
            trademoTrackingEvents(tabType === TABENUM.shared ? trackingEventDictionary.dashboardSearchHistoryReloadSavedSearchSharedWithMe : trackingEventDictionary.dashboardSearchHistoryReloadSavedSearch, { ...generateTrackingObject(location.pathname) });
            reloadSavedSearch(searchData);
          }}>
          Reload
          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#7143f1">
            <path d="M348.87-116.6q-61.14-26.6-106.4-71.87-45.27-45.26-71.87-106.4Q144-356 144-426h72q0 109 77.5 186.5T480-162q109 0 186.5-77.5T744-426q0-109-77.5-186.5T479.61-690H474l51 51-51 51-138-138 138-138 51 51-52 51h7q70 0 131.13 26.6 61.14 26.6 106.4 71.87 45.27 45.26 71.87 106.4Q816-496 816-426t-26.6 131.13q-26.6 61.14-71.87 106.4-45.26 45.27-106.4 71.87Q550-90 480-90t-131.13-26.6Z" />
          </svg>
        </div>
        {shareUserOptions?.length > 0 && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#7143f1"
            className="tw-cursor-pointer"
            onClick={() => {
              setOpenShareModal(true);
              setCurrentItem(searchData);
              trademoTrackingEvents(tabType === TABENUM.shared ? trackingEventDictionary.dashboardSearchHistoryShareSavedSearchSharedWithMe : trackingEventDictionary.dashboardShareSavedSearchesCreatedByMe, { ...generateTrackingObject(location.pathname) });
            }}>
            <path d="M648-96q-50 0-85-35t-35-85q0-9 4-29L295-390q-16 14-36.05 22-20.04 8-42.95 8-50 0-85-35t-35-85q0-50 35-85t85-35q23 0 43 8t36 22l237-145q-2-7-3-13.81-1-6.81-1-15.19 0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-23 0-43-8t-36-22L332-509q2 7 3 13.81 1 6.81 1 15.19 0 8.38-1 15.19-1 6.81-3 13.81l237 145q16-14 36.05-22 20.04-8 42.95-8 50 0 85 35t35 85q0 50-35 85t-85 35Zm0-72q20.4 0 34.2-13.8Q696-195.6 696-216q0-20.4-13.8-34.2Q668.4-264 648-264q-20.4 0-34.2 13.8Q600-236.4 600-216q0 20.4 13.8 34.2Q627.6-168 648-168ZM216-432q20.4 0 34.2-13.8Q264-459.6 264-480q0-20.4-13.8-34.2Q236.4-528 216-528q-20.4 0-34.2 13.8Q168-500.4 168-480q0 20.4 13.8 34.2Q195.6-432 216-432Zm432-264q20.4 0 34.2-13.8Q696-723.6 696-744q0-20.4-13.8-34.2Q668.4-792 648-792q-20.4 0-34.2 13.8Q600-764.4 600-744q0 20.4 13.8 34.2Q627.6-696 648-696Zm0 480ZM216-480Zm432-264Z" />
          </svg>
        )}
        <div
          className={reloadBtnCls}
          onClick={() => {
            setCurrentItem(searchData);
            setShowDeleteModal(true);
            if (tabType === TABENUM.shared) trademoTrackingEvents(trackingEventDictionary.dashboardSearchHistoryDeleteSavedSearchSharedWithMe, { ...generateTrackingObject(location.pathname) });
          }}>
          <svg className="tw-cursor-pointer" fill="#7143f1" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
            <path d="M292.309-140.001q-29.923 0-51.115-21.193-21.193-21.192-21.193-51.115V-720h-40v-59.999H360v-35.384h240v35.384h179.999V-720h-40v507.691q0 30.308-21 51.308t-51.308 21H292.309ZM680-720H280v507.691q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h375.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463V-720ZM376.155-280h59.999v-360h-59.999v360Zm147.691 0h59.999v-360h-59.999v360ZM280-720v520-520Z" />
          </svg>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={`tw-flex-1 tw-min-h-0 tw-overflow-auto tw-p-3 tw-pt-0 tw-rounded-lg tw-shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] tw-border tw-border-gray-200 tw-bg-white tw-flex tw-flex-col ${isLoading ? "tw-gap-1" : ""}`}>
        <div className="tw-flex tw-border-b tw-border-gray-200 tw-bg-white tw-gap-1 tw-mb-2 tw-pt-3 tw-sticky tw-top-0">
          <div
            className={`tw-text-sm tw-font-normal tw-leading-[1.43] tw-pt-0 tw-pr-4 tw-pb-[10px] tw-pl-1 tw-cursor-pointer ${currentTab === TABENUM.current ? "tw-text-primary-purple-600 tw-border-b-[2.5px] tw-border-b-primary-purple-500" : "tw-text-gray-500"}`}
            onClick={() => {
              setCurrentTab(TABENUM.current);
              trademoTrackingEvents(trackingEventDictionary.dashboardSavedSearchesCreatedByMe, { ...generateTrackingObject(location.pathname) });
            }}>
            Created by me
          </div>
          {!STARTERPLAN && (
            <div
              className={`tw-text-sm tw-font-normal tw-leading-[1.43] tw-pt-0 tw-pr-4 tw-pb-[10px] tw-pl-1 tw-cursor-pointer ${currentTab === TABENUM.shared ? "tw-text-primary-purple-600 tw-border-b-[2.5px] tw-border-b-primary-purple-500" : "tw-text-gray-500"}`}
              onClick={() => {
                setCurrentTab(TABENUM.shared);
                trademoTrackingEvents(trackingEventDictionary.dashboardSavedSearchesSharedWithMe, { ...generateTrackingObject(location.pathname) });
              }}>
              Shared with me
            </div>
          )}
        </div>
        {isLoading ? (
          <LoadingSkeleton lines={5} lineHeight="32px" width="100%" shape="rectangle" />
        ) : currentSearchData && Array.isArray(currentSearchData) && currentTab === TABENUM.current ? (
          <div className="tw-space-y-4">
            {Object.entries(groupByDate(currentSearchData)).map(([date, dateItems]) => (
              <div key={date} className="tw-flex tw-flex-col tw-gap-2">
                <div className="tw-font-medium tw-text-xs tw-text-gray-500 tw-border-b tw-border-gray-200 tw-pb-1">{date}</div>
                {dateItems.map((searchData) => renderSavedSearchItem(searchData, TABENUM.current))}
              </div>
            ))}
          </div>
        ) : sharedSearchData ? (
          <div className="tw-flex tw-flex-col tw-gap-5">
            {Object.entries(sharedSearchData).map(([key, value]) => {
              return (
                <div id={key} key={key}>
                  <div className="tw-text-xs tw-font-medium tw-leading-[1.33] tw-tracking-[-0.12px] tw-text-gray-500">{value[0]["shared_by_person_name"]}</div>
                  {value.map((searchData) => renderSavedSearchItem(searchData, TABENUM.shared))}
                </div>
              );
            })}
          </div>
        ) : (
          <></>
        )}
        {currentSearchData && currentSearchData?.length === 0 && currentTab === TABENUM.current && !isLoading && (
          <div className="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-text-center tw-px-6">
            <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-saved-icon-bg tw-flex tw-items-center tw-justify-center tw-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px" fill="#617cff">
                <path d="M220-150v-597.69Q220-778 241-799q21-21 51.31-21h375.38Q698-820 719-799q21 21 21 51.31V-150L480-261.54 220-150Z" />
              </svg>
            </div>
            <div>
              <p className="tw-font-semibold tw-text-sm tw-text-gray-900 tw-m-0">Nothing saved yet</p>
              {fromShipments ? (
                <p className="tw-text-sm tw-text-gray-500 tw-mt-1 tw-mb-0">Save a search to reuse its filters and keywords in one click.</p>
              ) : (
                <>
                  <p className="tw-text-sm tw-text-gray-500 tw-mt-1 tw-mb-0">Once you save any search, they will start appearing here.</p>
                  <p className="tw-text-sm tw-text-gray-500 tw-mb-0">To save a search:</p>
                  <p className="tw-text-sm tw-text-gray-500 tw-mb-0">Go to Search -&gt; Save Search</p>
                </>
              )}
            </div>
          </div>
        )}
        {sharedSearchData && Object.keys(sharedSearchData)?.length === 0 && currentTab === TABENUM.shared && !isLoading && (
          <div className="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-text-center tw-px-6">
            <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-saved-icon-bg tw-flex tw-items-center tw-justify-center tw-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px" fill="#617cff">
                <path d="M220-150v-597.69Q220-778 241-799q21-21 51.31-21h375.38Q698-820 719-799q21 21 21 51.31V-150L480-261.54 220-150Z" />
              </svg>
            </div>
            <div>
              <p className="tw-font-semibold tw-text-sm tw-text-gray-900 tw-m-0">Nothing shared yet</p>
              <p className="tw-text-sm tw-text-gray-500 tw-mt-1 tw-mb-0">Once you receive any search from your team, they will start appearing here.</p>
            </div>
          </div>
        )}{" "}
      </div>
      {openShareModal && <ShareSearch isOpen={openShareModal} onClose={() => setOpenShareModal(false)} currentItem={currentItem} shareUserOptions={shareUserOptions} getDashboardContacts={getDashboardContacts} type={currentTab} />}
      <Modal
        size="md"
        centered
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setCurrentItem({});
        }}
        animation={false}
        className="delete-modal">
        <Modal.Header closeButton>
          <Modal.Title>Delete Saved Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="saved-search-name">{getTitleCase(currentItem?.search_name)}</p>
          <p className="country-flag-imports">
            {!HIDE_DATASET_IDENTITY && !!currentItem.country && !!currentItem.trade_direction && currentItem.country !== "" && currentItem.trade_direction !== "" && (
              <span id={currentItem.country_code.toUpperCase() === "US" ? "us-pill" : currentItem.country_code.toUpperCase() === "MX" ? "mexico-pill" : currentItem.country_code.toUpperCase() === "CL" || currentItem.country_code.toUpperCase() === "CH" ? "chile-pill" : currentItem.country.toUpperCase() === "MULTICOUNTRY" ? "multi-pill" : "us-pill"} className={`saved-searhes-imports p-1 rounded ${currentItem.country.toUpperCase() === "MULTICOUNTRY" ? "d-flex align-items-center" : ""}`}>
                {currentItem.country_code.toLowerCase() === "world" ? <span className="material-symbols-outlined globe-image">public</span> : <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={currentItem.country_code.toUpperCase()} svg />}
                {currentItem.country.toUpperCase() === "MULTICOUNTRY" ? globalCountryDetails.multi_country.countryName : currentItem.country + " " + currentItem.trade_direction}
              </span>
            )}
          </p>
          <hr />
          <p className="confirm-delete">Please confirm if you would like to delete Saved Search</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
            onClick={() => {
              setShowDeleteModal(false);
              setCurrentItem({});
            }}>
            Cancel
          </button>
          <button className="btn btn-danger btn-sm trademo-btn-danger" onClick={() => deleteSavedSearch(currentItem)}>
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      {showSearchDeatilsModal && (
        <Suspense fallback={""}>
          <ViewSavedSearch childData={currentItem} handleModalClose={() => setShowSearchDeatilsModal(false)} isModalOpen={showSearchDeatilsModal} filterList={filterDictonary[filterCountry]} filterType={filterTypeDictionary} getUserDashboardData={getDashboardContacts} currentUserPlan={localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : ""} currentTab={currentTab} />
        </Suspense>
      )}
      {showEditSearchModal ? (
        <SaveSearch
          isDashboard={true}
          savedSearchShow={showEditSearchModal}
          handleClose={() => {
            setShowEditSearchModal(false);
            setCurrentItem({});
          }}
          analyticsCountryID={currentItem.country + "_" + currentItem.trade_direction}
          currentUserPlan={localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : ""}
          getDashboardData={() => getDashboardContacts()}
          redirectionId={!!currentItem && !!currentItem.country_code ? (countryCapsToSmall[currentItem.country.toLowerCase()] ? currentItem.product_id.toLocaleLowerCase().split("_")[1] + "_" + currentItem.trade_direction.toLocaleLowerCase() : currentItem.product_id.toLocaleLowerCase().split("_")[1] + "_" + currentItem.trade_direction.toLocaleLowerCase()) : ""}
          selectedTempData={currentItem}
          handleOpen={() => setShowEditSearchModal(true)}
          size="medium"
          currentTab={currentTab}
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default SavedSearches;
